/**
 * Sets a meta tag in the document's head. Adds the tag if it doesn't already
 * exist.
 *
 * @param kind "name" or "property".
 * @param name The value associated with the "name" or "property" attribute.
 * @param value The value of the "value" attribute (strips HTML tags).
 */
export function setMetaTag(
  kind: "name" | "property",
  name: string,
  value?: string
): void {
  const existing =
    document.querySelector(`meta[${kind}="${name}"]`) ??
    document.querySelector(`meta[${kind}="${name}"]`);
  if (!value) {
    if (existing) existing.remove();
    return;
  }
  const metaTag = existing ?? document.createElement("meta");
  if (!existing) {
    metaTag.setAttribute(kind, name);
    document.head.appendChild(metaTag);
  }

  // Sets the content attribute, stripping any HTML tags from the string.
  metaTag.setAttribute("content", value.replace(/(<([^>]+)>)/gi, ""));
}
